var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('g-header'),_c('el-row',{staticClass:"no-find-box"},[_c('el-row',[_c('img',{attrs:{"src":require("../../assets/images/404.png"),"alt":"404"}})]),_c('p',[_vm._v("你要找的页面不见了")])],1),_c('g-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }